import { Button, TextArea, Typography } from '@/components';
import { useAppTexts } from '@/contexts/AppTextsContext';
import AppText from '@/entities/AppText';
import AppTranslation from '@/entities/AppTranslation';
import { pushToDataLayer } from '@/utils/gtm';
import { useState } from 'react';
import styles from './TranslationEditor.module.css';

interface TranslationEditorProps {
  appText: AppText;
  translation: AppTranslation;
  isEditing: boolean;
  onEdit: () => void;
  onClose: () => void;
}

const TranslationEditor = ({
  appText,
  translation,
  isEditing,
  onEdit,
  onClose,
}: TranslationEditorProps): JSX.Element => {
  const [value, setValue] = useState<string>(translation.value);

  const { updateAndWriteTranslationValues } = useAppTexts();

  return (
    <div className={styles.content}>
      {isEditing ? (
        <div className={styles.contentEdition}>
          <TextArea
            rows={1}
            autoResize={true}
            onChange={(element) => setValue(element.target.value)}
            defaultValue={translation?.value}
          />
          <div className={styles.contentEditionActions}>
            <Button label="Cancel" variant="soft" onClick={onClose} />
            <Button
              label="Confirm"
              onClick={async () => {
                await updateAndWriteTranslationValues([{ translation, value }]);
                pushToDataLayer({ event: 'manual_translation_event' });
                onClose();
              }}
            />
          </div>
        </div>
      ) : (
        <div
          className={styles.valueContainer}
          onClick={() => {
            onEdit();
          }}
        >
          <div className={styles.value}>
            {!translation.value.trim() ? (
              <Typography style={{ color: 'red' }}>Empty</Typography>
            ) : (
              <Typography>{translation.value.trim()}</Typography>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TranslationEditor;
